:host {
  all: initial;
  --mobile-min-width: 225px;
  --mobile-max-width: 348px;
  --mobile-max-height: 486px;
  --mobile-aspect-ratio: 0.72;
}

.full-screen {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.15);
  z-index: 2147483647;
}

.preview-screen {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 !important;
}

.overlay-container {
  font-family: Arial, sans-serif;
  padding: 8px;
  color: #000;
}

.container {
  box-shadow: 0px 0px 16.2px 0px #00000040;
}

p {
  margin: 0;
}

p span {
  display: inline-block;
}

a {
  color: inherit;
}

.strong {
  font-weight: bold;
}

.hide {
  display: none !important;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0px, 0px, 0px, 0px);
  border: 0px;
}

.full-width {
  width: 100%;
}

.no-pointer * {
  pointer-events: none;
  cursor: default !important;
}

.input {
  width: 100%;
  font-size: 15px;
  padding: 16px;
  height: 51px;
  border: 1px solid rgb(198, 198, 198);
  box-sizing: border-box;
  background-color: white;
  overflow: hidden;
}

.input:not(.sc-om-custom-fields) {
  border-radius: var(--input-border-radius, 0px);
}
